<template>
	<FootprintTableSingle
		:edit-mode="false"
	/>
</template>

<script>
import FootprintTableSingle from './FootprintTableSingle'

export default {
	name: "FootprintTableSingleAdd",
	components: {
		FootprintTableSingle
	},

	methods: {
		validateFootprintType() {
			return Object.values(this.$route.params).length
		}
	},

	mounted() {
		!this.validateFootprintType() && this.$router.push({path: '/footprint'})
	}
}
</script>